import { Component, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NotificationService } from "../../../../shared/services/notification.service";
import { ToastrService } from "ngx-toastr";
import { FormGroup } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { GroupService } from "../../../user/services/group.service";
import { ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { ScheduleService } from "../../../../shared/services/schedule.service";

@Component({
    selector: 'app-custom-notification-form-component',
    templateUrl: './custom-notification-form-component.html',
})
export class CustomNotificationFormComponent  {
    model: any = {
        deviceType : '',
        action: 'open_link',
        language: '',
        memberType : '',
        display: 'app',
        groupId: null,
        groupSearchValue : {},
    };
    
    triggeredTime =  '';
    triggeredAt = null;
    jobId = null;
    
    testingMode = false;
    disableSubmit = false;
    labelObjectNavigator = 'Link url';
    
    actionTypes = [
        {
            value : 'open_link',
            displayName: 'Open link',
            displayLabel: 'Link url',
        },
        {
            value : 'view_profile',
            displayName: 'View profile',
            displayLabel: 'UserId (You can find it in the browser URL when viewing the user page)',
        },
        {
            value : 'view_photo',
            displayName: 'View photo',
            displayLabel: 'PhotoId',
        },
        {
            value : 'view_location',
            displayName: 'View location',
            displayLabel: 'LocationId',
        },
        {
            value : 'view_group',
            displayName: 'View group',
            displayLabel: 'GroupId (You can find it in the browser URL when viewing the group page)',
        },
        {
            value : 'view_battle',
            displayName: 'View battle',
            displayLabel: 'BattleId (You can find it in the browser URL when viewing the Battle detail)',
        }
    ]
    
    deviceTypeDisable = false;
    languageTypeHide = false;
    memberTypeDisable = false;
    descriptionDisable = false;
    deviceTypeHide = false;
    memberTypeHide = false;
    descriptionHide = false;
    minDate = moment().format(moment.HTML5_FMT.DATETIME_LOCAL);
    groupHide = false;
    groupForm = new FormGroup({});
    groupFields: FormlyFieldConfig[] = [
        {
            key: 'groupSearchValue',
            type: 'autocomplete',
            className: 'form-mb-0',
            // expressionProperties : {
            //     'templateOptions.disabled': () => {
            //         return  this.model.display === 'web'
            //     },
            // },
            templateOptions: {
                type: 'text',
                placeholder: 'Find photo club by name',
                required: false,
                change: (field, event) => {
                },
                autoOptions: {
                    isMapIcon: false,
                    clearOption: true,
                    displayField: 'title',
                    selectItem: (event, model) => {
                        setTimeout(() => {
                            this.model.groupId = model.groupSearchValue.id
                            this.memberTypeHide = true;
                            this.deviceTypeHide = true;
                            this.languageTypeHide = true;
                            this.model.deviceType = '';
                            this.model.memberType = '';
                            this.model.language = '';
                        }, 100)
                    },
                    clearItem: (event, model) => {
                        setTimeout(() => {
                            this.model.groupId = null;
                            this.memberTypeHide = false;
                            this.deviceTypeHide = false;
                            this.languageTypeHide = false;
                            this.groupForm.controls['groupSearchValue'].setValue({})
                        }, 100)
                    },
                    inputFormatter: (x) => {
                        return (typeof x === 'object') ? x['title'] : x;
                    },
                    remoteData: (term) => {
                        return this.groupService.searchGroup(term);
                    },
                }
            },
        },
    ]
    
    @Output()
    onRefresh: EventEmitter<any> = new EventEmitter<any>();
    
    constructor(
        public activeModal: NgbActiveModal,
        public notificationService: NotificationService,
        public scheduleService: ScheduleService,
        protected toastr: ToastrService,
        protected groupService: GroupService,
        protected route: ActivatedRoute
    ) {
    }
    
    ngOnInit() {
        this.testingMode = this.route.snapshot.queryParams.testingMode;
        if (this.triggeredTime) {
            this.triggeredAt = moment(this.triggeredAt).format(moment.HTML5_FMT.DATETIME_LOCAL);
        }
    }
    
    private handleScheduledNotification() {
        const selectedTriggeredAt = new Date(this.triggeredAt);
    
        if (selectedTriggeredAt < (new Date())) {
            this.toastr.error('The time select need should be in future', 'Error');
            return;
        }
    
        if (selectedTriggeredAt.getMinutes() != 0 && selectedTriggeredAt.getMinutes() != 30) {
            this.toastr.error('The minute should be 00 or 30 (Fex : 9:00, 9:30)', 'Error');
            return;
        }
    
        const jobData: any = {
            name: this.model.title,
            type: 'notification',
            params: this.model,
            triggeredAt: selectedTriggeredAt
        }
        
        if (this.model.groupId) {
            jobData.groupId = this.model.groupId;
        }
    
        let saveDataObs = null;
        if (this.jobId) {
            jobData.id = this.jobId;
            saveDataObs = this.scheduleService.updateSchedule(jobData);
        } else {
            saveDataObs = this.scheduleService.createSchedule(jobData);
        }
    
        saveDataObs.toPromise().then(res => {
            this.activeModal.close();
            this.toastr.success('Message is added to scheduled jobs.', 'SUCCESS');
            this.onRefresh.emit();
        })
    }
    
    createNotification(form) {
        if (form.valid) {
            if (this.triggeredTime) {
                return this.handleScheduledNotification();
            }
            
            this.notificationService.createNotification(this.model).toPromise().then(res => {
                this.activeModal.close();
                this.toastr.success('Push out message successfully', 'SUCCESS');
                this.onRefresh.emit();
            })
        }
    }
    
    changeActionType(event) {
        this.labelObjectNavigator = this.actionTypes[event.target.selectedIndex].displayLabel;
        this.model.navigateUrl = '';
    }
    
    changeDisplayType(event) {
        if (this.model.display == 'web') {
            this.deviceTypeHide = true;
            this.descriptionHide = true;
            this.model.deviceType = '';
            this.model.description = '';
        } else {
            this.deviceTypeHide = false;
            this.descriptionHide = false;
        }
    }
    
    preventEnterSubmit(event: KeyboardEvent) {
        if (!(event.target instanceof HTMLTextAreaElement)) {
            event.preventDefault();
        }
    }
}
